<script lang="ts">export let msg;
</script>

<div class="chat-log-entry">
  <div class="chat-log-entry-icon-col">
    <img alt="profile" src={msg.ImageUrl || '#'}>
  </div>
  {#if msg.MediaUrl || msg.MediaTextContent}
    <div class="chat-log-entry-media-col">
      <div class="twitter-media">
        {#if msg.MediaUrl}
          <img src={msg.MediaUrl} alt="media" />
        {/if}
        <div class="media-content">
          <div class="media-text">{msg.MediaTextContent || ''}</div>
          {#if msg.Author || msg.SourceName || msg.MediaAuthor}
            <div class="author-layout">
              {#if msg.Author || msg.MediaAuthor}
                <h4 for="" class="author">{msg.Author || msg.MediaAuthor}</h4>
              {/if}
              {#if msg.SourceName}
                <label for="" class="source">via {msg.SourceName}</label>
              {/if}
            </div>
          {/if}
        </div>
      </div>
      <div class="chat-log-entry-text-body">{msg.BodyText || ''}</div>
    </div>
  {:else}
    <div class="chat-log-entry-text-col">
      <div class="chat-log-entry-text-header">{msg.HeaderText || ''}</div>
      <div class="chat-log-entry-text-body">{msg.BodyText || ''}</div>
    </div>
  {/if}
</div>

<style type="text/scss">*, *:before, *:after {
  box-sizing: border-box;
}

.chat-log-entry:not(:first-child) {
  margin-top: 10px;
}

.chat-log-entry:not(:last-child) {
  margin-bottom: 10px;
}

.chat-log-entry {
  padding: 14px;
  border-radius: 25px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  -webkit-backdrop-filter: blur(7.51px);
  backdrop-filter: blur(7.51px);
  background: linear-gradient(198.39deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0));
  color: #000000;
  font-size: 12px;
}

.chat-log-entry-icon-col {
  padding-right: 7px;
  width: 50px;
  min-width: 50px;
  text-align: center;
}

.chat-log-entry-icon-col > img {
  width: 100%;
  display: block;
  border-radius: 50%;
}

.chat-log-entry-text-col {
  padding-left: 7px;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
}

.chat-log-entry-text-header {
  font-weight: bold;
  margin-bottom: 5px;
}

.chat-log-entry-media-col {
  width: calc(100% - 55px);
  display: flex;
  flex-direction: column;
  padding-left: 7px;
}

.chat-log-entry-media-col .twitter-media {
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  overflow: hidden;
}

.chat-log-entry-media-col .twitter-media img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.chat-log-entry-media-col .twitter-media .media-content {
  padding: 10px;
}

.chat-log-entry-media-col .twitter-media .media-content .media-text {
  font-size: 12px;
}

.chat-log-entry-media-col .twitter-media .media-content .author-layout {
  margin: 10px 0 0 0;
  display: flex;
  flex-direction: column;
}

.chat-log-entry-media-col .twitter-media .media-content .author-layout .author {
  font-size: 12px;
  font-weight: bold;
  margin: 0;
}

.chat-log-entry-media-col .twitter-media .media-content .author-layout .source {
  font-size: 12px;
}

.chat-log-entry-media-col .chat-log-entry-text-body {
  /* margin: 10px 0 0 0; */
}</style>
